import { Box, styled } from '@mui/material';

export const ConfigurationFormWrapper = styled(Box)(() => ({
  width: '100%',
}));
